import React, {useEffect} from "react";
import style from "../../../assets/scss/common/modal/aboutConsultantModal.module.scss";
import CloseBtn from "../../../assets/images/modal/close_btn.svg";
import {ConsultationItem} from "../../../types/consultation";
import {useConsultationGetter} from "../../sub/consultation/hooks/useConsultationGetter";
import {useModalScrollLock} from "./consultation/hooks/useModalScrollLock";
import {useTranslation} from "react-i18next";

interface AddChildModalProps {
    isOpen: boolean;
    selectedConsultation: ConsultationItem | null;
    onClose: () => void;
}

const AboutConsultantModal: React.FC<AddChildModalProps> = (
    {isOpen, onClose, selectedConsultation}) => {
    const { t } = useTranslation("consultant");
    useModalScrollLock(isOpen); // 모달 밖 스크롤 제한
    const {getConsultantInfo, consultantInfo} = useConsultationGetter();

    useEffect(() => {
        if (!selectedConsultation?.counselingIdx) return;
        isOpen && getConsultantInfo(selectedConsultation?.counselingIdx).then();
        // eslint-disable-next-line
    }, [selectedConsultation]);

    if (!isOpen) {
        return null;
    }

    const consultantImage = consultantInfo?.image === null
        ? 'https://test-sadare-bucket.s3.ap-northeast-2.amazonaws.com/image/admin_profile_image/2025/1/2/default_human_img.svg'
        : consultantInfo?.image.uri

    return (
        <div className={style.addChildModalOverlay}>
            <div className={style.addChildInfoModal}>
                <div className={style.closeBtnContainer}>
                    <img
                        src={CloseBtn}
                        alt="closeBtn"
                        className={style.closeBtn}
                        onClick={() => onClose()}
                    />
                </div>
                {consultantInfo && (
                    <div className={style.innerModalContainer}>
                        <h3 className={style.addChildInfoTitle}>{t('detail.modal.consultant.title')}</h3>
                        <div className={style.innerTextContainer}>
                            <div className={style.infoContainer}>
                                <span className={style.infoTitleText}>{t('detail.modal.consultant.subTitle')}</span>
                                {/* 이미지 */}
                                <div className={style.imgContainer}>
                                    <div className={style.imgBorderContainer}>
                                        <div className={style.imgWrapper}>
                                            <img
                                                className={style.consultantImg}
                                                alt={"consultant_img"}
                                                src={consultantImage}
                                            /></div>
                                    </div>
                                </div>
                                <span className={style.infoText}>{t('detail.modal.consultant.name')}</span>
                                <span className={style.inputField}>{consultantInfo.consultantName}</span>
                                <span className={style.infoText}>{t('detail.modal.consultant.email')}</span>
                                <span className={style.inputField}>{consultantInfo.email}</span>
                                <span className={style.infoText}>{t('detail.modal.consultant.cellPhone')}</span>
                                <span className={style.inputField}>{consultantInfo.phoneNumber}</span>
                            </div>
                        </div>
                        <div className={style.innerTextContainer}>
                            <div className={style.infoContainer}>
                                <span className={style.infoTitleText}>{t('detail.modal.consultant.history')}</span>
                                <div className={style.aboutConsultantContainer}>
                                    {consultantInfo.briefHistory}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AboutConsultantModal;
